import {
  OverlayDrawer,
  DrawerHeader,
  DrawerHeaderTitle,
  DrawerBody,
  Table,
  TableBody,
  Button,
  Checkbox,
  CheckboxProps,
} from '@fluentui/react-components'
import { Dismiss24Regular } from '@fluentui/react-icons'
import { FC, useMemo } from 'react'
import { ProjectList } from '@/types'
import { CalendarProjectInfoMap, DefaultCalendarColorName } from './PMCalendar.Common'
import { ColorButton } from './PMCalendar.ColorSelector'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { setCalendarInfoForProject } from '@/actions/uiActions'

interface IProps {
  isOpen: boolean
  setIsOpen: (open: boolean) => void
  projects: ProjectList
  projectInfoMap: CalendarProjectInfoMap
}

export const CalendarProjectsModal: FC<IProps> = ({ isOpen, setIsOpen, projects, projectInfoMap }) => {
  const sortedProjects = useMemo(() => projects.sortBy(p => p!.get('name').toLowerCase()), [projects])
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const rows = sortedProjects
    .map((p, i) => {
      if (!p) return
      const name = p.get('name')
      const idd = p.get('idd')
      const color = projectInfoMap.get(idd)?.color ?? DefaultCalendarColorName
      const display = projectInfoMap.get(idd)?.display ?? true
      const onChangeCheckbox: CheckboxProps['onChange'] = (_evt, { checked }) => {
        dispatch(setCalendarInfoForProject({ idd, display: !!checked }))
      }

      return (
        <div className="my-2 flex w-full flex-row items-center" key={idd}>
          <Checkbox onChange={onChangeCheckbox} checked={display} />
          <ColorButton color={color} idd={idd} />
          <span className="flex-1 overflow-hidden overflow-ellipsis whitespace-nowrap">{name}</span>
        </div>
      )
    })
    .toArray()
  return (
    <OverlayDrawer open={isOpen} onOpenChange={(_, { open }) => setIsOpen(open)}>
      <DrawerHeader>
        <DrawerHeaderTitle
          action={
            <Button
              appearance="subtle"
              aria-label="Close"
              icon={<Dismiss24Regular />}
              onClick={() => setIsOpen(false)}
            />
          }
        >
          {t('calendar.projects')}
        </DrawerHeaderTitle>
      </DrawerHeader>

      <DrawerBody>
        <Table noNativeElements>
          <TableBody>{rows}</TableBody>
        </Table>
      </DrawerBody>
    </OverlayDrawer>
  )
}
